const getJsonLdScriptId = (type?: string) => {
    if (type === "HomePage") {
        return "home-page-structured-data";
    }

    if (type === "ProductDetailsPage") {
        return "product-structured-data";
    }

    return "";
};

export default getJsonLdScriptId;
